// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  padding: 0 10px;
}
ion-content.eintracht {
  --background: #282828;
}

ion-footer.invalid {
  background: darkgrey;
  color: grey;
}

.header-content {
  background: #282828;
  display: flex;
  padding: calc(24px + var(--ion-safe-area-top, 0px)) 20px 0;
  align-items: center;
  justify-content: space-between;
}
.header-content .back-arrow-btn {
  display: flex;
  cursor: pointer;
}
.header-content ion-icon {
  width: 22px;
  height: 22px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/order/order.page.scss"],"names":[],"mappings":"AACA;EACE,eAAA;AAAF;AACI;EACE,qBAAA;AACN;;AAGA;EACE,oBAAA;EACA,WAAA;AAAF;;AAGA;EACI,mBAAA;EACA,aAAA;EACA,0DAAA;EACA,mBAAA;EACA,8BAAA;AAAJ;AAEI;EACE,aAAA;EACA,eAAA;AAAN;AAGI;EACE,WAAA;EACA,YAAA;AADN","sourcesContent":["\nion-content {\n  padding: 0 10px;\n    &.eintracht {\n      --background: #282828;\n  }\n}\n\nion-footer.invalid {\n  background: darkgrey;\n  color: grey;\n}\n\n.header-content {\n    background: #282828;\n    display: flex;\n    padding: calc(24px + var(--ion-safe-area-top, 0px)) 20px 0;\n    align-items: center;\n    justify-content: space-between;\n\n    .back-arrow-btn {\n      display: flex;\n      cursor: pointer;\n    }\n    // box-shadow: 0px 4px 45px 0px #00000014;\n    ion-icon {\n      width: 22px;\n      height: 22px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
